// 🔴 N°591/N°593 — OUTIL DE CAPTURE DE LA DICTÉE · PREPROD SEULEMENT, ⛔ JAMAIS main.
//
// POURQUOI : la forme des événements Web Speech de Chrome ANDROID (resultIndex,
// interims, finals cumulatifs ou non, ré-émissions) ⛔ n'est PAS la forme
// desktop, et nos bancs l'ont RECONSTITUÉE. Cet outil l'ENREGISTRE telle
// qu'elle arrive, UNE fois, sur le téléphone de JJ.
//
// CE QU'IL FAIT : si l'URL porte `?capture_dictee=1` (retenu pour l'onglet),
// il enveloppe l'objet de reconnaissance et journalise, SANS RIEN MODIFIER du
// comportement : chaque `onresult` brut (resultIndex + tous les results avec
// transcript / isFinal / confidence), les événements de cycle (start, audio,
// speech, end, error, nomatch) et l'user-agent. À la fin d'une dictée
// (`onend`), il envoie le journal à `/api/visite/diagnostic/dictee`, qui
// l'écrit dans un FICHIER (⛔ rien en base).
// Format = celui des fixtures `__fixtures__/dictee/*.json` (provenance
// « capturee »), pour être rejoué tel quel par les bancs.
// Sans le paramètre : ⛔ AUCUN effet (fonction qui rend immédiatement).

const CLE = "omnihub-capture-dictee";

export function captureActive() {
  try {
    if (new URLSearchParams(window.location.search).get("capture_dictee") === "1") {
      sessionStorage.setItem(CLE, "1");
    }
    return sessionStorage.getItem(CLE) === "1";
  } catch {
    return false;
  }
}

function copieResultats(event) {
  const out = [];
  for (let i = 0; i < event.results.length; i++) {
    const r = event.results[i];
    out.push({
      transcript: r[0] ? r[0].transcript : "",
      isFinal: !!r.isFinal,
      confidence: r[0] ? r[0].confidence : null,
      alternatives: r.length,
    });
  }
  return out;
}

export function instrumenterCapture(rec) {
  if (!rec || !captureActive()) return;
  const t0 = () => Math.round(performance.now());
  let journal = null;
  const nouveau = () => ({
    provenance: "capturee",
    motif: "Capture brute sur appareil (outil preprod N°593).",
    plateforme: navigator.userAgent,
    config: { continuous: rec.continuous, interimResults: rec.interimResults, lang: rec.lang },
    debut: new Date().toISOString(),
    evenements: [],
    cycle: [],
  });
  const cycle = (nom, extra) => {
    if (!journal) journal = nouveau();
    journal.cycle.push({ t: t0(), evenement: nom, ...(extra || {}) });
  };
  ["start", "audiostart", "soundstart", "speechstart", "speechend",
   "soundend", "audioend", "nomatch"].forEach((nom) =>
    rec.addEventListener(nom, () => cycle(nom)));
  rec.addEventListener("error", (e) => cycle("error", { error: e.error }));

  const onresultProduit = rec.onresult;
  rec.onresult = (event) => {
    if (!journal) journal = nouveau();
    journal.evenements.push({ t: t0(), resultIndex: event.resultIndex,
                              results: copieResultats(event) });
    cycle("result", { n: journal.evenements.length - 1 });
    if (onresultProduit) onresultProduit(event);   // ⛔ comportement inchangé
  };
  const onendProduit = rec.onend;
  rec.onend = (event) => {
    if (onendProduit) onendProduit(event);         // ⛔ comportement inchangé
    cycle("end");
    const envoi = journal;
    journal = null;
    if (!envoi || !envoi.evenements.length) return;
    envoi.fin = new Date().toISOString();
    try {
      fetch("/api/visite/diagnostic/dictee", {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(envoi),
      }).catch(() => {});
    } catch {}
  };
}
